import constants from 'constants/index'

const isTemplate = (company) =>
  company?.kind === constants.preRegistrations.TEMPLATE_KIND

export default isTemplate
